function h(o, r, f, u, t, c, m, p) {
  var e = typeof o == "function" ? o.options : o;
  r && (e.render = r, e.staticRenderFns = f, e._compiled = !0);
  var n;
  if (t && (n = t), n)
    if (e.functional) {
      e._injectStyles = n;
      var d = e.render;
      e.render = function(l, i) {
        return n.call(i), d(l, i);
      };
    } else {
      var a = e.beforeCreate;
      e.beforeCreate = a ? [].concat(a, n) : [n];
    }
  return {
    exports: o,
    options: e
  };
}
export {
  h as n
};
